import { render } from "./channelAddDrawer.vue?vue&type=template&id=42284fb2&scoped=true"
import script from "./channelAddDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./channelAddDrawer.vue?vue&type=script&setup=true&lang=js"

import "./channelAddDrawer.vue?vue&type=style&index=0&id=42284fb2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42284fb2"],['__file',"src/views/exhibitionManage/components/channelAddDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42284fb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42284fb2', __exports__)) {
    console.log('reload')
    api.reload('42284fb2', __exports__)
  }
  
  module.hot.accept("./channelAddDrawer.vue?vue&type=template&id=42284fb2&scoped=true", () => {
    console.log('re-render')
    api.rerender('42284fb2', render)
  })

}


export default __exports__